<template>
  <v-card align="center" justify="center" outlined class="color-picker-card">
    <v-icon class="close-icon" @click="close">fa-times</v-icon>
    <v-card-title class="color-picker-title">
      <h2>{{ $t('title') }}</h2>
    </v-card-title>
    <v-card-text class="pa-5">
      <v-color-picker v-model="color" mode="hexa" hide-mode-switch flat/>
      <v-divider class="my-2"/>
      <div class="pa-3" v-html="$t('contrastMessage')" readonly rounded/>
      <v-divider class="my-2"/>
      <v-btn class="ma-3" @click="saveColor">{{ $t('btnSave') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    initialColor: String,
  },
  data() {
    return {
      color: '',
    };
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      this.color = `#${this.initialColor}`;
    },
    saveColor() {
      this.$emit('saveColor', this.color);
    },
    close() {
      this.$emit('closeWindow');
    },
  },
}
</script>



<style scoped>
.color-picker-card {
  position: relative;
}

.color-picker-title {
  padding-right:60px;
}

.close-icon {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  z-index: 1;
  font-size: 16px;
  padding: 8px;
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.2s ease;
}

.close-icon:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 1);
}

.theme--light .close-icon {
  color: rgba(0, 0, 0, 0.5);
}

.theme--light .close-icon:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.8);
}
</style>
